import { useEffect } from 'react';

const GoogleAnalytics = ({ measurementId }) => {
  useEffect(() => {
    if (!measurementId) return;

    // Load Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    // Initialize Google Analytics
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', measurementId);

    // Track WhatsApp button clicks
    const trackWhatsAppClick = (event) => {
      const href = event.currentTarget.href;
      gtag('event', 'contact', {
        method: 'whatsapp',
        event_category: 'engagement',
        event_label: 'WhatsApp Contact'
      });
    };

    // Add event listeners to WhatsApp links
    const whatsappLinks = document.querySelectorAll('a[href*="wa.me"]');
    whatsappLinks.forEach(link => {
      link.addEventListener('click', trackWhatsAppClick);
    });

    // Cleanup
    return () => {
      whatsappLinks.forEach(link => {
        link.removeEventListener('click', trackWhatsAppClick);
      });
    };
  }, [measurementId]);

  return null;
};

export default GoogleAnalytics;
